import React, { useMemo, useEffect, useState, forwardRef, useRef } from "react";
import "../styles/schedule.css";
import editIcon from "../assets/icons/edit_icon.svg";
import FocusIcon from "../assets/icons/focus-swirl.svg";
import RelaxIcon from "../assets/icons/relax-vector.svg";
import { AddSessionType } from "./Data/constants";
import { getCurrentTimeFormatted, timeToMinutes } from "./Util/TimeUtil";
import { getText, TextId } from "./Util/TextHelper";

const ScheduleList = forwardRef(
  ({ scheduleData, onEditSession }, ref) => {
    const [currentTime, setCurrentTime] = useState(getCurrentTimeFormatted());
    const listRef = useRef(null);
    const cardRef = useRef(null);

    useEffect(() => {
      if (typeof ref === "function") {
        ref(listRef.current);
      } else if (ref) {
        ref.current = listRef.current;
      }
    }, [ref]);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentTime(getCurrentTimeFormatted());
      }, 60000);
      return () => clearInterval(interval);
    }, []);

    const upcomingSchedule = useMemo(() => {
      const sortedData = [...scheduleData].sort((a, b) => {
        const timeA = getCurrentTimeFormatted(a?.start?.dateTime) || "";
        const timeB = getCurrentTimeFormatted(b?.start?.dateTime) || "";

        if (!timeA || !timeB) return 0;
        return timeToMinutes(timeA) - timeToMinutes(timeB);
      });

      const next = sortedData.find((data) => {
        const sessionTime = getCurrentTimeFormatted(data?.start?.dateTime);
        return (
          sessionTime && timeToMinutes(sessionTime) > timeToMinutes(currentTime)
        );
      });

      return next ? getCurrentTimeFormatted(next?.start?.dateTime) : null;
    }, [currentTime, scheduleData]);

    if (!scheduleData.length) {
      return (
      <div className="loading-container">
         <h3 style={{ color: "white", fontFamily: "Poppins" }}>
           {getText(TextId.noScheduleMessage)}
         </h3>
       </div>
      // <p className="">{getText(TextId.noScheduleMessage)}</p>;
       );
    }

    return (
      <div className="scheduleList" ref={listRef}>
        {scheduleData.map((data, index) => {
          const sessionTimeFormatted = getCurrentTimeFormatted(
            data?.start?.dateTime
          );
          const isRelax = data?.categories.includes("Zensory-RELAX");
          return (
            <div
              ref={index === 0 ? cardRef : null}
              className={`scheduleCard ${
                upcomingSchedule === sessionTimeFormatted
                  ? "upcoming-schedule-time"
                  : ""
              }`}
              key={data?.id}
            >
              <div className="scheduleCard-firstRow">
                <span className="scheduleCard-title">
                  {data?.displaySubject}
                </span>
                <div className="scheduleCard-info">
                  <span>{data?.durationMinutes} Mins</span>
                  <div
                    className={`type ${
                        isRelax
                        ? AddSessionType.Relax
                        : AddSessionType.Focus
                    }`}
                  >
                    <img
                      src={
                          isRelax ? RelaxIcon : FocusIcon
                      }
                      alt={
                          isRelax
                          ? "relaxIcon"
                          : "focusIcon"
                      }
                    />
                    {isRelax ? "Relax" : "Focus"}
                  </div>
                </div>
              </div>

              <div className="scheduleCard-secondRow">
                <span>{sessionTimeFormatted}</span>
                {onEditSession && (
                  <span onClick={() => onEditSession(data)}>
                    <img src={editIcon} alt="editIcon" /> 
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
);

export default React.memo(ScheduleList);
